import { useMemo } from "react";
import { FEATURE_BADGES } from "@/core/config/feature-badges";

/**
 * Retorna o conjunto de IDs de menu que ainda devem exibir a badge "Novo".
 * A badge expira automaticamente após `durationDays` dias da `startDate`.
 */
export function useFeatureBadge(): Set<string> {
  return useMemo(() => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const active = new Set<string>();

    for (const { menuId, startDate, durationDays = 14 } of FEATURE_BADGES) {
      const [y, mo, d] = startDate.split("-").map(Number);
      const start = new Date(y, mo - 1, d);

      const expiry = new Date(y, mo - 1, d + durationDays);

      if (today >= start && today < expiry) {
        active.add(menuId);
      }
    }

    return active;
  }, []);
}
